import {Context, createContext, PropsWithChildren} from "react";

export interface StyleContextAttributes<VariantType> {
  variant?: VariantType;
}

export const createStyleContext = <VariantType,>() => {
  return createContext<StyleContextAttributes<VariantType>>({});
};
interface StyleContextProviderProps<VariantType> extends PropsWithChildren {
  style: StyleContextAttributes<VariantType>;
}

export const StyleContextProviderFactory = <VariantType,>(context: Context<StyleContextAttributes<VariantType>>) => {
  return ({style, children}: StyleContextProviderProps<VariantType>) => {
    return <context.Provider value={style}>{children}</context.Provider>;
  };
};
